import { Extension } from '@tiptap/core'

export const TextCase = Extension.create({
  name: 'textCase',

  addCommands() {
    return {
      setTextCase: (caseType) => ({ tr, state, dispatch }) => {
        if (dispatch) {
          const { selection, doc } = state
          const { empty, from, to } = selection

          let start = from
          let end = to

          // If no text is selected, apply to the entire document
          if (empty) {
            start = 0
            end = doc.content.size
          }

          let items = []
          doc.nodesBetween(start, end, (node, pos) => {
            if (node.isBlock) {
              items.push({ type: 'block' })
            } else if (node.isText) {
              // Skip if the text is inside a chord
              const hasChord = node.marks.some(mark => mark.type.name === 'chordClass')
              if (!hasChord) {
                items.push({ type: 'text', node, pos })
              }
            }
          })

          let isStartOfWord = true
          if (start > 0 && caseType === 'capitalize') {
            try {
              let charBefore = doc.textBetween(start - 1, start)
              if (charBefore && !/\s/.test(charBefore)) {
                isStartOfWord = false
              }
            } catch (e) {
              // ignore out of bounds errors at document start
            }
          }

          let newTexts = []

          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            if (item.type === 'block') {
              isStartOfWord = true
            } else if (item.type === 'text') {
              let { node, pos } = item
              let replaceStart = Math.max(start, pos)
              let replaceEnd = Math.min(end, pos + node.nodeSize)
              let textToReplace = node.text.substring(replaceStart - pos, replaceEnd - pos)
              
              let replacedText = ''
              if (caseType === 'lower') {
                replacedText = textToReplace.toLowerCase()
              } else if (caseType === 'upper') {
                replacedText = textToReplace.toUpperCase()
              } else if (caseType === 'capitalize') {
                for (let j = 0; j < textToReplace.length; j++) {
                  let char = textToReplace[j]
                  if (/\s/.test(char)) {
                    isStartOfWord = true
                    replacedText += char // keep whitespace as is
                  } else {
                    if (isStartOfWord) {
                      replacedText += char.toUpperCase()
                      isStartOfWord = false
                    } else {
                      replacedText += char.toLowerCase()
                    }
                  }
                }
              }

              if (replacedText !== textToReplace) {
                newTexts.push({
                  replaceStart,
                  replaceEnd,
                  newText: replacedText
                })
              }
            }
          }

          // Apply backwards so positional changes (if any) do not affect unprocessed indices
          for (let i = newTexts.length - 1; i >= 0; i--) {
            let change = newTexts[i]
            tr.insertText(change.newText, change.replaceStart, change.replaceEnd)
          }
          return true
        }
        return true
      }
    }
  }
})
